var map = {
	"./de-DE.json": [
		2938,
		2
	],
	"./en-GB.json": [
		2939,
		3
	],
	"./en-US.json": [
		2940,
		4
	],
	"./es-419.json": [
		2941,
		5
	],
	"./es-ES.json": [
		2942,
		6
	],
	"./fr-CA.json": [
		2943,
		7
	],
	"./fr-FR.json": [
		2944,
		8
	],
	"./id-ID.json": [
		2945,
		9
	],
	"./it-IT.json": [
		2946,
		10
	],
	"./ja-JP.json": [
		2947,
		11
	],
	"./nl-NL.json": [
		2948,
		12
	],
	"./pt-BR.json": [
		2949,
		13
	],
	"./zh-CN.json": [
		2950,
		14
	],
	"./zh-Hans-CN.json": [
		2951,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1341;
module.exports = webpackAsyncContext;